import React from 'react';
import { Check } from 'lucide-react';
import { cn } from '../../lib/utils';
interface ProgressStepperProps {
  steps: string[];
  currentStep: number;
  onStepClick?: (step: number) => void;
}
export function ProgressStepper({
  steps,
  currentStep,
  onStepClick
}: ProgressStepperProps) {
  return <div className="w-full py-4" data-id="element-390">
      <div className="flex items-center justify-between relative" data-id="element-391">
        {/* Connecting Line */}
        <div className="absolute left-0 top-1/2 transform -translate-y-1/2 w-full h-0.5 bg-gray-200 -z-10" data-id="element-392" />
        <div className="absolute left-0 top-1/2 transform -translate-y-1/2 h-0.5 bg-primary-600 -z-10 transition-all duration-300" style={{
        width: `${(currentStep - 1) / (steps.length - 1) * 100}%`
      }} data-id="element-393" />

        {steps.map((step, index) => {
        const stepNumber = index + 1;
        const isCompleted = stepNumber < currentStep;
        const isCurrent = stepNumber === currentStep;
        return <div key={index} className="flex flex-col items-center cursor-pointer relative z-10" onClick={() => isCompleted && onStepClick && onStepClick(stepNumber)} data-id="element-394">
              <div className={cn('w-8 h-8 rounded-full flex items-center justify-center border-2 transition-colors bg-white mb-2', isCompleted ? 'border-primary-600 bg-primary-600 text-white' : isCurrent ? 'border-primary-600 text-primary-600' : 'border-gray-300 text-gray-400')} data-id="element-395">
                {isCompleted ? <Check className="h-4 w-4" data-id="element-396" /> : <span className="text-xs font-bold" data-id="element-397">{stepNumber}</span>}
              </div>
              <span className={cn('text-[10px] font-medium whitespace-nowrap transition-colors text-center absolute top-10 w-32 left-1/2 -translate-x-1/2', isCurrent ? 'text-primary-700' : 'text-gray-500',
          // Hide label if not current or first/last on mobile to save space
          !isCurrent && 'hidden sm:block')} data-id="element-398">
                {step}
              </span>
            </div>;
      })}
      </div>
    </div>;
}